export class ObjectToArrayStageImpl {
    constructor(arrayFieldName, destinationFieldName) {
        this.arrayFieldName = arrayFieldName;
        this.destinationFieldName = destinationFieldName;
    }
    toProto() {
        return {
            objectToArray: {
                arrayFieldName: this.arrayFieldName,
                destinationFieldName: this.destinationFieldName,
            },
        };
    }
}
//# sourceMappingURL=ObjectToArrayStage.js.map